import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Gift, Copy, Check, Users } from "lucide-react";

const InviteModal = ({ open, onClose, refCode }) => {
  const [copied, setCopied] = useState(false);
  const link = refCode ? `${window.location.origin}/?ref=${refCode}` : "";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch (e) {
      /* clipboard blocked — link still shown for manual copy */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const share = async () => {
    const text = `Come play Footie Clash with me — draft your XI and take me on! ${link}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: "Footie Clash", text });
      } else {
        await copy();
      }
    } catch (e) {
      /* cancelled */
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="invite-modal" className="theme-light w-[calc(100%-2rem)] bg-[#1E293B] border border-[#10B981]/30 text-white max-w-sm p-6">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-[#10B981]/15 border border-[#10B981]/30 flex items-center justify-center mb-1">
          <Gift className="w-7 h-7 text-[#10B981]" />
        </div>
        <DialogTitle className="font-display font-extrabold text-2xl text-center">Invite &amp; earn</DialogTitle>
        <DialogDescription className="text-muted-38 text-sm text-center mt-1">
          Share your link. When a mate signs up for a real account, you <span className="text-[#10B981] font-semibold">both get £30 virtual</span>.
        </DialogDescription>

        <div className="mt-5 flex items-center gap-2">
          <input
            data-testid="invite-ref-input"
            readOnly
            value={link}
            onFocus={(e) => e.target.select()}
            placeholder="Loading your link…"
            className="flex-1 min-w-0 rounded-lg bg-black/25 border border-white/10 px-3 py-2.5 text-xs text-slate-200 outline-none"
          />
          <button
            data-testid="invite-copy-btn"
            onClick={copy}
            disabled={!link}
            className="btn-green rounded-lg px-3 py-2.5 text-sm font-semibold flex items-center gap-1 shrink-0 disabled:opacity-50"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            {copied ? "Copied" : "Copy"}
          </button>
        </div>

        <button
          data-testid="invite-share-btn"
          onClick={share}
          disabled={!link}
          className="btn-green w-full rounded-xl py-3 font-semibold mt-3 flex items-center justify-center gap-2 disabled:opacity-50"
        >
          <Users className="w-4 h-4" /> Share invite
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default InviteModal;
